import { render, staticRenderFns } from "./CompraDiretaFerramentaDeBusca.vue?vue&type=template&id=021b8956"
import script from "./CompraDiretaFerramentaDeBusca.vue?vue&type=script&lang=js"
export * from "./CompraDiretaFerramentaDeBusca.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaFerramentaDeBusca.vue?vue&type=style&index=0&id=021b8956&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports